import { convertFromStringToBool } from '@hooks/useFilterObject';

import type { FilterInputData } from '../types/filter-input-data';
import type { VerktoyFiltersSettingsInput } from '../types/filter-settings-input';
import type { VerktoyFiltersSettings } from '../types/verktoy-filter-settings';
import type { QueryMapSetup } from '@src/types/minhelseentities';
import type { VerktoyFilterState } from '@src/types/stateTypes';
import type { SortDirection, SortField, SortValue } from '@src/types/verktoyFilterTypes';

export const getDefaultSortKey = (valgtSortering?: string, valgtSorterstigende?: string): SortValue => {
  if (!valgtSortering) {
    return 'VerktoyNavn-true';
  }
  const sortDirection = convertFromStringToBool(valgtSorterstigende).toString();
  return `${valgtSortering}-${sortDirection}` as SortValue;
};

export const createSortKey = (field: SortField, direction: SortDirection): SortValue => `${field}-${direction}` as SortValue;

export enum FilterSortOption {
  VerktoyNavnAsc = 'VerktoyNavn-true',
  VerktoyNavnDesc = 'VerktoyNavn-false',
  PublisertDatoAsc = 'PublisertDato-true',
  PublisertDatoDesc = 'PublisertDato-false',
}

export const parseSortValue = (value: string): { field: string; direction: string } => {
  if (value === 'VerktoyNavn-true') {
    return { field: 'VerktoyNavn', direction: '' };
  }
  const [field, direction] = value.split('-');
  return { field, direction };
};

export function getFilterValue(allValues: QueryMapSetup[], queryParam: string, activeFilters: { name: string; value: string }[]): string[] {
  const filteredValuesFromDropdown = activeFilters?.filter(e => e.name.includes(queryParam)) ?? [];
  const dropdownActiveDisplayname = filteredValuesFromDropdown.map(e => e.value);
  return allValues.filter(e => dropdownActiveDisplayname.includes(e.displayname)).map(e => e.value);
}

export function getCurrentFilterSelection(filterInput: FilterInputData): VerktoyFilterState {
  return {
    SokeString: filterInput.searchValueUrl ?? '',
    IsAnonymCheckboxChecked: !!filterInput.filters?.[filterInput.URLQueryParamNames.StotterAnonymOppstart],
    Fagomrader: getFilterValue(filterInput.fagomraader, filterInput.URLQueryParamNames.Fagomrade, filterInput.activeFilters),
    Malgrupper: getFilterValue(filterInput.malgrupper, filterInput.URLQueryParamNames.Malgruppe, filterInput.activeFilters),
    VerktoyTyper: getFilterValue(filterInput.verktoytyper, filterInput.URLQueryParamNames.VerktoyType, filterInput.activeFilters),
    Sortering: filterInput.valgtSortering,
    SorterStigende: filterInput.valgtSorterstigende,
  };
}

export const createVerktoyFiltersSettings = (input: VerktoyFiltersSettingsInput): VerktoyFiltersSettings => ({
  stotterAnonymOppstartChecked: input.stotterAnonymOppstartChecked,
  stotterAnonymOppstartCheckedValue: input.resources?.visKunVerktoySomKanApnesAnonymt,
  fagomraadeValueFromUrl: input.fagomraader,
  fagomraadeValgt: input.fagomraderValgt,
  malgrupperValueFromUrl: input.malgrupper,
  malgrupperValgt: input.malgrupperValgt,
  verktoytyperValueFromUrl: input.verktoytyper,
  verktoytyperValgt: input.verktoytyperValgt,
});
